<div [class.disabled-container]="isDisabled">
	<!-- Button group -->
	<div
		[ngClass]="buttonSize"
		class="btn-group"
		role="group"
	>
		<ng-container *ngFor="let checkboxes of checkboxGroup; let iLast = last">
			<ng-container *ngFor="let checkbox of checkboxes; let jLast = last">
				<input
					type="checkbox"
					[(ngModel)]="checkbox.selected"
					(ngModelChange)="updateSelected()"
					[disabled]="isDisabled"
					class="btn-check"
					[id]="id + checkbox.code"
					autocomplete="off"
				/>
				<label
					class="btn btn-light"
					[for]="id + checkbox.code"
					[ngTooltip]="checkbox?.info!"
					[ngClass]="options?.btnClass!"
					[class.active]="checkbox.selected"
					[class.me-3]="!iLast && jLast"
				>
					<!-- Option name -->
					<span *ngIf="!checkbox?.image">{{ checkbox.name }}</span>

					<!-- image if available -->
					<img
						*ngIf="checkbox?.image"
						[src]="checkbox.image"
						width="21px"
						height="21px"
					/>
				</label>
			</ng-container>
		</ng-container>
	</div>
</div>
